import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent, Children, cloneElement } from 'react';
import classnames from 'classnames';
import { getGrid } from './utils';

var Grid =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Grid, _PureComponent);

  var _super = _createSuper2(Grid);

  function Grid() {
    _classCallCheck(this, Grid);

    return _super.apply(this, arguments);
  }

  _createClass(Grid, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$width = _this$props.width,
          width = _this$props$width === void 0 ? 1 : _this$props$width,
          offset = _this$props.offset,
          responsive = _this$props.responsive,
          stretch = _this$props.stretch,
          children = _this$props.children,
          gutter = _this$props.gutter,
          other = _objectWithoutProperties(_this$props, ["width", "offset", "responsive", "stretch", "children", "gutter"]);

      var autoCount = 0;
      var settleWidth = 0;
      Children.toArray(children).forEach(function (child) {
        if (child.type && child.type.isGrid) {
          if (child.props.width) settleWidth += child.props.width;else autoCount += 1;
        }
      });
      var autoWidth = autoCount > 0 ? (1 - settleWidth) / autoCount : 0;
      var className = classnames(this.props.className, getGrid({
        width: width,
        offset: offset,
        responsive: responsive
      }));
      var style = Object.assign({}, this.props.style);

      if (gutter && gutter > 0) {
        style.width = 'auto';
        style.display = 'block';
        style.marginLeft = "".concat(0 - gutter / 2, "px");
        style.marginRight = "".concat(0 - gutter / 2, "px");
      }

      return (
        /*#__PURE__*/
        React.createElement("div", Object.assign({}, other, {
          style: style,
          className: className
        }), Children.toArray(children).map(function (child) {
          if (child.type && child.type.isGrid) {
            var pps = {
              style: Object.assign({}, child.props.style)
            };
            if (!child.props.width) pps.width = autoWidth;
            if (stretch) pps.style = _objectSpread2(_objectSpread2({}, pps.style), {}, {
              minHeight: '100%',
              height: '100%'
            });

            if (gutter && gutter > 0) {
              pps.style = _objectSpread2(_objectSpread2({}, pps.style), {}, {
                paddingLeft: gutter / 2,
                paddingRight: gutter / 2
              });
            }

            return (
              /*#__PURE__*/
              cloneElement(child, pps)
            );
          }

          return child;
        }))
      );
    }
  }]);

  return Grid;
}(PureComponent);

Grid.isGrid = true;
Grid.displayName = 'ShineoutGrid';
export { Grid as default };